import httpClient from './httpClient'

export const getEmailNotifications = async (payload) => {
  const endpoint = '/EmailNotifications/' + payload
  return httpClient.get(endpoint)
}

export const updateEmailNotifications = async (payload) => {
  const endpoint = '/refusers/UpdateUserEmailNotification/'
  return httpClient.put(endpoint, payload)
}

export default {
  getEmailNotifications,
  updateEmailNotifications,
}
